"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var height = _a.height;
    if (!height) {
        return null;
    }
    if (typeof height === 'object') {
        var _b = height.min, min = _b === void 0 ? '' : _b, _c = height.max, max = _c === void 0 ? '' : _c;
        return "\n      " + (min && "min-height: " + min + ";") + "\n      " + (max && "max-height: " + max + ";") + "\n    ";
    }
    return "height: " + height + ";";
});
